"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionToolbar = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const input_checkbox_1 = require("../../components/input/input.checkbox");
const mithril_component_1 = require("../../components/mithril.component");
const sortable_1 = require("../../components/sortable/sortable");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const tag_sort_state_1 = require("../../state/tag.sort.state");
const store_1 = require("../../store");
const collection_edit_menu_1 = require("../collection.edit.menu/collection.edit.menu");
const export_menu_1 = require("../export.menu/export.menu");
const topological_editor_button_1 = require("../topological.editor.button/topological.editor.button");
const collection_toolbar_style_1 = require("./collection.toolbar.style");
(0, theme_1.addStyles)(collection_toolbar_style_1.Style);
class CollectionToolbar extends mithril_component_1.IMithrilComponent {
    get title() {
        const tag = store_1.AppStore.Tag.get(page_state_1.CurrentState.inspectedTagId);
        if (tag == null) {
            return (0, i18n_1.Translate)(this.defaultTitle);
        }
        if (tag.name != null) {
            return tag.name;
        }
        return (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE);
    }
    constructor(state, cfg = {}) {
        super();
        this.state = state;
        this.editMenu = new collection_edit_menu_1.CollectionEditMenu();
        this.exportMenu = new export_menu_1.ExportMenu();
        this.sortable = new sortable_1.Sortable(tag_sort_state_1.TagSortState);
        this.mapZoomOut = cfg.mapZoomOut;
        this.defaultTitle = cfg.title;
    }
    get nodes() {
        const showMapModeButton = this.mapZoomOut === false &&
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_MODE) &&
            (services_1.Services.UserProfile.get(services_1.Services.User.current.objectId)
                ? !services_1.Services.UserProfile.isReadOnly(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId))
                : false);
        if (page_state_1.CurrentState.Tag.tags.length === 0) {
            const title = this.title;
            const selectedUuid = page_state_1.CurrentState.inspectedCollectionRevision
                ? store_1.AppStore.CollectionSummary.get(page_state_1.CurrentState.inspectedCollectionRevision).uuid
                : null;
            return (0, mithril_1.m)('div', { key: 'selection-toolbar', className: collection_toolbar_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: collection_toolbar_style_1.CSS.title, title }, title),
                showMapModeButton ? topological_editor_button_1.TopologicalEditorCollectionButton.view(page_state_1.CurrentState.inspectedTagId, selectedUuid) : null,
                (0, mithril_1.m)('div', { className: collection_toolbar_style_1.CSS.tools }, [
                    this.sortable.view(),
                    this.mapZoomOut === false
                        ? null
                        : image_button_1.ImageButton.view(icons_1.MaterialIcon.ZOOM_OUT_MAP, {
                            onclick: this.state.map.centerMap,
                            title: i18n_1.T.TAG_ZOOM,
                        }),
                ]),
            ]);
        }
        const checkboxState = {
            isSelected: () => this.state.allSelected,
            setSelected: (val) => page_state_1.CurrentState.Tag.selectAll(this.state.filteredTags, val),
        };
        return (0, mithril_1.m)('div', { key: 'selection-toolbar', className: collection_toolbar_style_1.CSS.container }, [
            input_checkbox_1.CheckBox.view(checkboxState),
            (0, mithril_1.m)('div', { className: collection_toolbar_style_1.CSS.text }, (0, i18n_1.Translate)(i18n_1.T.TAG_TITLE_SELECTION, page_state_1.CurrentState.Tag.collectionSize)),
            this.viewSelectedTools(),
        ]);
    }
    viewSelectedTools() {
        if (!page_state_1.CurrentState.Tag.ready) {
            return spinner_1.Spinner.view();
        }
        return (0, mithril_1.m)('div', { className: collection_toolbar_style_1.CSS.tools }, [this.exportMenu.view(), this.editMenu.view()]);
    }
}
exports.CollectionToolbar = CollectionToolbar;
tslib_1.__decorate([
    mobx_1.computed
], CollectionToolbar.prototype, "title", null);
//# sourceMappingURL=collection.toolbar.js.map